export default function AccountDeletion() {
  return (
    <div className="container legal-shell">
      <div className="card">
        <h1>Account Deletion Request</h1>
        <p>
          To request deletion of your AffiTrack account and associated workspace data, email{" "}
          <a href="mailto:support@affitrack.net">support@affitrack.net</a> from the email address
          on your account with the subject line <strong>Account Deletion Request</strong>.
        </p>
        <p>
          Please include your account email and, if applicable, your workspace name so we can
          verify the request and process it safely.
        </p>
        <p>
          When a deletion request is confirmed, we will remove the account profile, workspace
          membership, tracked programs, and associated app data that are no longer required to
          operate or secure the service.
        </p>
        <p>
          Limited billing, payment, and compliance records may be retained for legal, tax, fraud
          prevention, or dispute-resolution purposes for the minimum period required by law or our
          payment providers.
        </p>
        <p>
          If you only want billing canceled and do not want the account deleted, you can manage
          subscription changes separately from the Billing section of the app or by contacting
          support.
        </p>
      </div>
    </div>
  );
}
